// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230522/js/" + chunkId + "." + {"44":"a8701af5","225":"068e6495","481":"55687f9d","486":"999bd097","770":"ce543e4f"}[chunkId] + ".0.36567745402676144.chunk.js";
};